// RRULE UTILS
import {RRule, rrulestr} from 'rrule';
import moment from 'moment/moment';
import {get, isEmpty, forEach} from 'lodash';

const DaysOfWeekMap = {
    1: RRule.MO,
    2: RRule.TU,
    3: RRule.WE,
    4: RRule.TH,
    5: RRule.FR,
    6: RRule.SA,
    7: RRule.SU,
};

export const getFrequency = (sessState) => {
    switch (sessState?.customIntervalType) {
        case 'day':
            return RRule.DAILY;
        case 'week':
            return RRule.WEEKLY;
        default:
        case 'month':
            return RRule.MONTHLY;
    }
};

const getDefaultIntervalDigit = (sessState) => {
    switch (sessState?.intervalType) {
        case 'week':
            return 1;
        case '2week':
            return 2;
        case '3week':
            return 3;
        case '4week':
            return 4;
        default:
            return 1;
    }
};

const getDaysOfWeekInterval = (sessState) => {
    const daysOfWeekArr = [];

    sessState.daysOfWeek.forEach((day) => daysOfWeekArr.push(DaysOfWeekMap[day]));

    return daysOfWeekArr;
};

// const getRruleDate = (date) => {
//     const {year, month, day, hour, minute, second} = {
//         year: moment(date).year(),
//         month: moment(date).month(),
//         day: moment(date).date(),
//         hour: moment(date).hour(),
//         minute: moment(date).minute(),
//         second: moment(date).second(),
//     };
//
//     return [year, month, day, hour, minute, second];
// };

export const modifyRruleString = (sessState) => {
    if (!sessState.rrule) return '';

    const rruleObj = RRule.fromString(sessState.rrule);

    const newEndDate = moment(sessState.endDate).toDate();

    const updatedRrule = new RRule({
        ...rruleObj.options,
        until: newEndDate,
    });

    return updatedRrule.toString();
}

const getDefaultInterval = (sessState) => {
    const number = getDefaultIntervalDigit(sessState);

    return new RRule({
        interval: number,
        freq: RRule.WEEKLY,
        until: moment(sessState.endDate).toDate(),
        dtstart: moment(sessState.startDate).toDate(),
        byweekday: getDaysOfWeekInterval(sessState),
    });
};

const getCustomInterval = (sessState) => {
    const number = parseInt(sessState?.customIntervalNumber, 10) || 1;

    return new RRule({
        freq: getFrequency(sessState),
        interval: number,
        until: moment(sessState.endDate).toDate(),
        dtstart: moment(sessState.startDate).toDate(),
        byweekday: getDaysOfWeekInterval(sessState),
    });
};

export const getIntervalRrule = (sessionState) => {
    if (!!sessionState?.customInterval) {
        return getCustomInterval(sessionState);
    } else {
        return getDefaultInterval(sessionState);
    }
};

// export const getOccurrencesForSession = (
//     session,
//     startRange,
//     endRange,
//     rrulePath,
// ) => {
//     const sessionRule = get(session, rrulePath || 'rrule');
//     const rule = rrulestr(sessionRule);
//
//     return rule.between(startRange.toDate(), endRange.toDate(), true);
// };


export const getSlotsForSession = (session, from, to) => {
    const result = [];
    if (!session?.rrule) return;
    let rule = rrulestr(session.rrule);
    let sessStart = moment(session.startDate).set({second:0,millisecond:0});
    let slotEnd = sessStart.clone().add(session.slotDurationInMinutes,"minute")
    let sessEnd = moment(session.startDate).set({hour:moment(session.endDate).hour(),minute:moment(session.endDate).minute(),second:0,millisecond:0});
    let slotHours = [];
    while(slotEnd.isSameOrBefore(sessEnd, 'minute')) {
        slotHours.push({hour:sessStart.hour(),minute:sessStart.minute(),second:0,millisecond:0});
        slotEnd = slotEnd.add(session.slotDurationInMinutes,"minute")
        sessStart = sessStart.add(session.slotDurationInMinutes,"minute")
    }
    const start = from;
    const end = to;

    const eventDates = rule.between(
        start.toDate(),
        end.toDate(),
        true,
    );
    //console.log('getSlotsForSession rrule options', rule.options, session.rrule);
    session.daySlots = {};
    if (!isEmpty(eventDates)) {
        forEach(eventDates, dt => {
            let slotdate =  moment(dt).format('YYYY_MM_DD');
            session.daySlots[slotdate] = [];
            forEach(slotHours, h=> {
                session.daySlots[slotdate].push({startDate: moment(dt).set(h),assignedSession:session.sessionId});
                //session.slots.push({startDate: moment(dt).set(h)});
            })
        });
    }
    //console.log('getSlotsForSession generated', session.slots);
    return result;
};

// export const filterSessionsByDateRange = (sessions, startDate, endDate) => {
//     const start = moment(startDate);
//     let end =
//         endDate && moment(endDate).isAfter(start, 'day') ? moment(endDate) : null;
//
//     return sessions.filter((session) => {
//         if (!session.rrule) return false;
//         if (!end) {
//             end = moment(session.endDate);
//         }
//
//         const rule = rrulestr(session.rrule);
//         const occurrences = rule.between(start.toDate(), end.toDate(), true);
//
//         return occurrences.length > 0;
//     });
// };
//
// export const isBarsSessionActiveOnDay = (session, dayOfWeek) => {
//     if (!session.rrule) return false;
//
//     const rule = rrulestr(session.rrule);
//     const ruleOptions = rule.origOptions;
//
//     if (ruleOptions.byweekday) {
//         const rruleDayOfWeek = dayOfWeek - 1; // ISO format (1-7) to RRule format (0-6)
//
//         return ruleOptions.byweekday.some((weekdayOption) => {
//             if (typeof weekdayOption === 'number') {
//                 return weekdayOption === rruleDayOfWeek;
//             }
//             if (
//                 typeof weekdayOption === 'object' &&
//                 weekdayOption.weekday !== undefined
//             ) {
//                 return weekdayOption.weekday === rruleDayOfWeek;
//             }
//             return false;
//         });
//     }
//
//     return false;
// };

// Formatted strings
// export const formatRRuleInterval = (rruleString) => {
//     const rule = rrulestr(rruleString);
//     const interval = rule.options.interval || 1;
//     const frequency = rule.options.freq;
//
//     const frequencyMap = {
//         [RRule.YEARLY]: 'year',
//         [RRule.MONTHLY]: 'month',
//         [RRule.WEEKLY]: 'week',
//         [RRule.DAILY]: 'day',
//         [RRule.HOURLY]: 'hour',
//         [RRule.MINUTELY]: 'minute',
//         [RRule.SECONDLY]: 'second',
//     };
//
//     const freqText = frequencyMap[frequency];
//     if (!freqText) return 'Unknown frequency';
//
//     return interval > 1
//         ? `Every ${interval} ${freqText + (interval > 1 ? 's' : '')}`
//         : `Every ${freqText}`;
// };

export const printDaysOfWeek = (rruleString, printFormat = 'dddd') => {
    const rule = rrulestr(rruleString);
    const ruleOptions = rule.origOptions;

    if (ruleOptions.byweekday) {
        const dayArr = ruleOptions.byweekday.map((day) =>
            moment()
                .isoWeekday(day.weekday + 1)
                .format(printFormat),
        );

        return dayArr.join(', ');
    } else {
        return '-';
    }
};
